import { makeRequest, CommonRequestOptions } from '../makeRequest';

export type RespondToWorkOrderSignoffRequestResponse = {
   date: number;
   displayDate: string;
   entryid: number;
   status: 'approved' | 'rejected';
   stepid: number;
   type: 'team';
   userAvatar: string;
   userProfile: string;
   userid: number;
   username: string;
};

export async function respondToWorkOrderSignoffRequest(
   entryId: number,
   stepId: number,
   status: 'approved' | 'rejected',
   password?: string,
   token?: string,
   { ...common }: CommonRequestOptions = {}
): Promise<RespondToWorkOrderSignoffRequestResponse> {
   if (password !== undefined && password !== '') {
      return makeRequest('post', `/work_log/${entryId}/step/${stepId}/signoff`, {
         ...common,
         body: {
            status,
            password,
         },
      });
   }

   return makeRequest('post', `/work_log/${entryId}/step/${stepId}/signoff/token`, {
      ...common,
      body: {
         status,
         token,
      },
   });
}
